import React from 'react';
import InstallDialog from './InstallDialog';
import useInstall from './useInstall';

export default function Install() {
    const { isOpen, install, dismiss } = useInstall();
    return <InstallDialog isOpen={isOpen} onClose={dismiss} onInstall={install} />;
}
